import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { UI_LANGS, normalizeUiLang } from '@/i18n/locale-config'
import { useAuthConfig } from './useAuthConfig'

const FALLBACK_CODES = ['zh', 'en'] as const

/** 租户启用的用户端 UI 语言(来自 GET /auth/config.ui_languages) */
export function useTenantUILanguages() {
  const { config, loading, error, reload } = useAuthConfig()
  const { i18n } = useTranslation()

  const codes = useMemo(() => {
    const raw = config?.ui_languages
    if (!raw?.length) return [...FALLBACK_CODES]
    const valid = new Set<string>(UI_LANGS.map((l) => l.code))
    const filtered = raw.filter((c) => valid.has(c))
    return filtered.length > 0 ? filtered : [...FALLBACK_CODES]
  }, [config?.ui_languages])

  const langs = useMemo(
    () => UI_LANGS.filter((l) => codes.includes(l.code)),
    [codes],
  )

  useEffect(() => {
    if (loading || langs.length === 0) return
    const current = normalizeUiLang(i18n.resolvedLanguage ?? i18n.language)
    if (!codes.includes(current)) {
      void i18n.changeLanguage(langs[0]?.code ?? 'zh')
    }
  }, [loading, codes, langs, i18n])

  return { codes, langs, loading, error, reload }
}
